var exports = {
  "kL": "xa15a2ab7--224e5a--container",
  "Tp": "xa15a2ab7--224e5a--background",
  "iE": "xa15a2ab7--224e5a--wrapper",
  "nu": "xa15a2ab7--224e5a--wrapper--compact",
  "DD": "xa15a2ab7--224e5a--title",
  "ag": "xa15a2ab7--224e5a--title--compact",
  "VO": "xa15a2ab7--224e5a--full-width",
  "O0": "xa15a2ab7--224e5a--rating",
  "vA": "xa15a2ab7--224e5a--with--label",
  "ik": "xa15a2ab7--224e5a--with--compact",
  "wm": "xa15a2ab7--224e5a--logo",
  "Pf": "xa15a2ab7--224e5a--label",
};

module.exports = exports;
